import React from "react";
import PropTypes from "prop-types";

import SaveSearchOverlay from "../containers/save_search_overlay";

export default (FilterBox, Breadcrumbs, MainView) => {
  class Root extends React.Component {
    render () {
      let lockOverlay;
      if (this.props.searchIsBeingSaved) {
        lockOverlay = <div className="row root-overlay-wrapper"><SaveSearchOverlay /></div>;
      }

      return (
        <div className="react-app-root">
          <FilterBox />
          <Breadcrumbs />
          <MainView />
          {lockOverlay}
        </div>
      );
    }
  }

  Root.propTypes = {
    searchIsBeingSaved: PropTypes.bool.isRequired,
  };

  return Root;
};
